<template>
    <div>
        <Header></Header>
        <div class="sellingForm">
            <div class="top-message">
                <h1>出品画面</h1>
            </div>
            <form action="#">
                <div class="name">
                    <p>商品名</p>
                    <input type="text" v-model.trim="item" class="itemName">
                </div>
                <div class="exhibition">
                    <p>画像を選択(.pngファイルまたは.jpegファイルのみ、正方形推奨)</p>
                    <input type="file" accept="image/png, image/jpeg" @change="uploadFile"><br>
                    <img :src=img_url>
                </div>
                <div class="condition-select">
                    <p>商品の状態</p>
                    <select v-model="condition">
                        <option>新品・未使用</option>
                        <option>未使用に近い</option>
                        <option>目立った傷や汚れ無し</option>
                        <option>やや傷や汚れあり</option>
                        <option>傷や汚れあり</option>
                        <option>全体的に状態が悪い</option>
                    </select>
                </div>
                <div class="condition">
                    <p>商品の説明</p>
                    <textarea id="item-condition" cols="80" rows="7" placeholder="教科書の破損状態や使用した授業などを詳しく書いてください" v-model.trim="description"></textarea>
                </div>       
                <div class="price">
                    <p>販売価格(半角で入力してください)</p>
                <input type="number" id="price" name="password" v-model.number="price"><nobr>円</nobr><br>
                </div>
                <p class="vertification">出品前にもう一度内容を確認してください。<br>内容に間違いがなければ出品ボタンを押して出品を完了させてください。</p>
            </form>
            <div class="btn-wrapper">
                <div>
                    <button v-if="isPushed" class="btn sell" @click="exhibitItem" style="cursor: pointer;">出品する</button>
                    <h3 v-else>出品が完了しました。「ホームに戻る」ボタンを押してください</h3>
                </div>
                <br>
                <router-link to="/landing" class="btn back">ホームに戻る</router-link>
            </div>
        </div>
        <menu-bar class="menu-bar"></menu-bar>

    </div>
</template>

<script>
import Header from '../components/Header.vue'
import firebase from 'firebase'
import db from '../plugins/firestore'
import storage from '../plugins/storage'
import MenuBar from '../components/MenuBar.vue'
// import Compressor from 'compressorjs'
import imageCompression from '../components/compressor'



export default {
    components: {Header,MenuBar},
    data(){
        return {
            userProfile: '', //ユーザ情報（userオブジェクトが入っている）
            item:'', //教科書名
            description:'', //商品の説明
            condition:'', //商品の状態
            price: '', //価格
            isSold: true, //商品の販売状況（初期値は販売中）
            img_url:'https://firebasestorage.googleapis.com/v0/b/ritsbook-997bf.appspot.com/o/images%2Fcamera.png?alt=media&token=de6c74f8-f799-448d-8625-f8a34258b531', //商品画像のULR
            imageName: '',//画像の名前
            imageFile: '',
            itemID: '',
            isPushed: true
        }
    },
    created() {
        firebase.auth().onAuthStateChanged(user => {
            if(!user){
                this.$router.push({path: "/"})
            }else{
                this.userProfile = user
            }
        })
    },
    methods: {
        async uploadFile(e) {
            //ファイルを取得
            var files = e.target.files;
            console.log(files)

            console.log('start')
            const compressedImage=await imageCompression.getCompressImageFile(
                files[0],
                console.log('finish')
            );
            //ファイル名を取得
            // ファイル名ランダム
            this.imageName = Math.random().toString(32).substring(2);
            //ファイルを取得
            this.imageFile = compressedImage;
            //ストレージオブジェクト作成
            const storageRef = storage.ref()
            // ファイルのパスを設定
            var mountainsRef = storageRef.child(`images/${this.imageName}`);
            // ファイルを適用してファイルアップロード開始
            mountainsRef.put(this.imageFile).then(snapshot => {
                snapshot.ref.getDownloadURL().then(downloadURL => {
                    this.img_url = downloadURL;
                });
            });
        },
        exhibitItem(){
            if(this.item == ''){
                alert('商品名が空白です')
            }else if(this.description == ''){
                alert('商品説明欄が空白です')
            }else if(this.condition == ''){
                alert('商品の状態を選択してください')
            }else if(this.price == ''){
                alert('価格を設定してください')
            }else{
                this.isPushed = !this.isPushed
                db.collection("textbooks").add({ // itemコレクションに以下のデータを追加
                seller: this.$store.getters.profile.faculity+"/"+this.$store.getters.profile.grade+"回生"+"/"+this.$store.getters.profile.userName,
                // faculity: this.$store.getters.profile.faculity,
                item: this.item, //商品名
                description: this.description, //詳細
                condition: this.condition, //商品状態
                price: Number(this.price), //値段
                isSold: this.isSold, //販売中かどうか？（初期状態はtrue）
                userID: this.userProfile.uid, //userID
                img_url: this.img_url, //商品画像のURL
                timestamp: firebase.firestore.FieldValue.serverTimestamp() //出品日時
                })
                .then(function(docRef) {
                    //本当は、出品ボタンを押すと当時にホームに戻る処理を書きたかったが、$routerが聞かなかったので、ユーザにホームに戻るボタンを押させて処理を任せる。
                    alert('出品しました！「ホームに戻るボタン」を押してホームに戻ってください。')
                    // db.collection("users").doc(this.userProfile.uid).collection("sellinglist").doc(docRef.id).set({
                    //     itemID: docRef.id
                    // })
                    console.log("Document written with ID: ", docRef.id);
                })
                .catch(function(error) {
                    console.error("Error adding document: ", error);
                });
            }
        }
    }
}
</script>

<style scoped>
.top-message p {
    margin-top: 10px;
}


form{
    margin: 0 auto;
    text-align: center;
}

.exhibition {
    margin-top: 40px;
}

.exhibition img{
    margin-top: 20px;
}

label{
    text-align: left;
}

textarea {
    width: 31%;
    height: 80px;
    border-style: solid;
    border-width: 1px;
    border-radius: 5px;
    padding: 5px;
}

img{
    width: 200px;
    /* height: 200px; */
    /* object-fit: cover; この一行を追加するだけ！ */
} 

.condition {
    margin-top: 40px;
}

.condition-select {
    margin-top: 40px;
}

.price {
    margin-top: 40px;
}


#price {
    width: 20%;
    height: 30px;
    margin: 0 auto;
    margin-bottom: 20px;
    padding: 0px 10px;
    border-style: solid;
    border-width: 0.5px;
    border-radius: 10px;
}

.itemName {
    width: 30%;
    height: 30px;
    margin: 0 auto;
    margin-bottom: 20px;
    padding: 0px 10px;
    border-style: solid;
    border-width: 0.5px;
    border-radius: 10px;
}

select {
    width: 20%;
    height: 40px;
    margin: 0 auto;
    margin-bottom: 20px;
    padding: 0px 10px;
    border-style: solid;
    border-width: 1px;
    border-radius: 10px;
}

.vertification {
    margin-top: 30px;
    font-weight: normal;
}

.btn {
    padding: 8px 60px;
    margin: 30px 0;
    color: white;
    display: inline-block;
    opacity: 0.8;
    border-radius: 4px;
    text-align: center;
}

.decide {
    background-color: rgb(52, 24, 192);
    color: white;
}

.sell {
    background-color:rgba(255,0, 0, 0.9);
}

.sell:hover {
    background-color:rgba(255,0, 0, 1);
}

.back {
    font-size: 13px;
    background-color:  rgb(34, 49, 52);
    text-decoration: none;
}

.back:hover {
    background-color:  rgba(34, 49, 52, 0.9);
}

.btn-wrapper {
    text-align: center;
    margin-bottom: 10%;
}

@media all and (max-width:670px){
    .top-message h1{
        font-size: 20px;
    }
    
    .exhibition img {
        width: 200px;
    }

    textarea{
        width: 60%;
    }

    /* img {
        /* width: 50%; */
    /* } */

    input .itemName{
        width: 70%;
    }

    select {
        width: 60%;
    }

    #price {
        width: 60%;
    }
}
</style>